import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import styled from 'styled-components/native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { useTheme } from '@theme/ThemeProvider';
import { Text } from './Text';

interface CheckboxProps extends Omit<TouchableOpacityProps, 'onPress'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
}

const Container = styled(TouchableOpacity)`
  flex-direction: row;
  align-items: center;
  padding-vertical: ${({ theme }) => theme.spacing.sm}px;
`;

const CheckboxBox = styled.View<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: ${({ theme }) => theme.radius.xs}px;
  border-width: 2px;
  border-color: ${({ theme, checked }) =>
    checked ? theme.colors.brandPrimary : theme.colors.border};
  background-color: ${({ theme, checked }) =>
    checked ? theme.colors.brandPrimary : theme.colors.surface};
  align-items: center;
  justify-content: center;
`;

const LabelContainer = styled.View`
  flex: 1;
  margin-left: ${({ theme }) => theme.spacing.md}px;
`;

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  description,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Container onPress={() => onChange(!checked)} activeOpacity={0.7} {...props}>
      <CheckboxBox checked={checked}>
        {checked && <Icon name="check" size={16} color={theme.colors.surface} />}
      </CheckboxBox>
      {label && (
        <LabelContainer>
          <Text variant="body" color="textPrimary">
            {label}
          </Text>
          {description && (
            <Text variant="caption" color="textSecondary" style={{ marginTop: 2 }}>
              {description}
            </Text>
          )}
        </LabelContainer>
      )}
    </Container>
  );
};
